import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import MatchTermsFilteredList from './MatchTermsFilteredList'

export default function MatchTermsFilteredDialog({ category, matchTerms, setMatchTerm, setContactName, ...overlay }) {
  const { t } = useTranslation()
  const doneBtnOnClick = () => {
    overlay.close()
  }
  return (
    <DialogOverlay
      {...overlay}
      title={t('tools.lists.headings.resultsCount', 'Search Results')}
      subtitle={getSearchResultsMessage(category, matchTerms, t)}
    >
      <MatchTermsFilteredList
        matchTerms={matchTerms}
        setMatchTerm={setMatchTerm}
        setContactName={setContactName}
        {...overlay}
      />

      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="medium" onClick={doneBtnOnClick}>
            {t('action.done', 'Done')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}

function getSearchResultsMessage(category, matchTerms, t) {
  switch (category) {
    case 'christian-religion-names':
    case 'fictitious':
    case 'mythological':
    case 'non-holocaust-countries':
    case 'primary-death-camp-names':
    case 'profanity':
    case 'religious-titles':
    case 'secondary-death-camp-names':
      if (matchTerms.length > 1) {
        return t('tools.lists.headings.termsFound', '{count} terms found', {
          count: matchTerms.length,
        })
      }
      return t('tools.lists.headings.termFound', '{count} term found', {
        count: matchTerms.length,
      })
    case 'holocaust-contributor-ids':
      if (matchTerms.length > 1) {
        return t('tools.lists.headings.contributorsFound', '{count} contributors found', {
          count: matchTerms.length,
        })
      }
      return t('tools.lists.headings.contributorFound', '{count} contributor found', {
        count: matchTerms.length,
      })
    default:
      return t('tools.lists.labels.term', 'Term')
  }
}
